<template>
  <div class="search-results-page">
    <Header />
    
    <div class="search-header">
      <button @click="goBack" class="btn-back-search"><i class="fa-solid fa-arrow-left"></i> Voltar</button>
      <div class="title-wrapper">
        <h2><i class="fa-solid fa-magnifying-glass"></i> Resultados da Busca</h2>
        <p>Buscando por: <strong>"{{ queryTerm }}"</strong></p>
      </div>
    </div>

    <div class="search-container">
      <div v-if="loading" class="loading-search">
        <div class="spinner"></div>
        <p>Procurando profundamente nos materiais...</p>
      </div>

      <div v-else-if="results.length === 0" class="no-results">
        <i class="fa-solid fa-folder-open"></i>
        <h3>Nenhum resultado encontrado</h3>
        <p>Não encontramos a palavra "{{ queryTerm }}" em nossos PDFs e materiais.</p>
      </div>

      <div v-else class="results-list">
        <div class="result-card" v-for="(item, index) in results" :key="index">
          <div class="result-type">
            <i class="fa-solid fa-file-pdf"></i> Material / Biblioteca
          </div>
          
          <h3 class="result-title" v-html="item.titulo"></h3>
          
          <!-- Snippet contendo a palavra grifada -->
          <div class="result-snippet" v-html="highlightTerm(item.snippet)"></div>
          
          <!-- Botão para o visualizador -->
          <router-link :to="{ name: 'book', query: { amd: item.amd, hash: item.hash } }" class="btn-access">
            Acessar Material <i class="fa-solid fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
// import '@/styles/SearchResults.css';
import request from '@/router/request';

export default {
  name: 'SearchResults',
  components: { Header },
  data() {
    return {
      queryTerm: '',
      loading: true,
      results: []
    }
  },
  watch: {
    '$route.query.q': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.queryTerm = newVal;
          this.fetchResults();
        }
      }
    }
  },
  methods: {
    async fetchResults() {
      this.loading = true;
      this.results = [];

      try {
        const response = await request.post('/biblioteca-virtual/buscar', {
          termo: this.queryTerm
        });

        // O response de Elasticsearch vem como response.data.hits.hits
        const hits = response.data?.hits?.hits || [];

        this.results = hits.map(hit => {
          const source = hit._source || {};
          const highlight = hit.highlight || {};

          let snippet = '';
          if (highlight.conteudo && highlight.conteudo.length > 0) {
            snippet = highlight.conteudo.join(' ... ');
          } else {
            snippet = this.generateSnippet(source.conteudo || '', this.queryTerm);
          }

          let titulo = source.titulo || 'Material Sem Título';
          if (highlight.titulo && highlight.titulo.length > 0) {
            titulo = highlight.titulo[0];
          }

          return {
            titulo,
            amd: source.amd,
            hash: source.hash,
            snippet
          };
        });

        // Fallback: Se não retornou nada (banco vazio local, docker offline, erro na api de prod), 
        // mostra um resultado visual mockado para você testar a interface!
        if (this.results.length === 0) {
            console.warn('Backend não retornou resultados ou ES offline. Exibindo Mock Visual para teste.');
            this.results = [
              {
                titulo: 'Livro Padrão de Engenharia (Mock)',
                amd: '20260701',
                hash: 'mock1',
                snippet: `...um trecho importante que contém a palavra ${this.queryTerm} para validar o funcionamento do destaque visual no texto...`
              },
              {
                titulo: 'Cálculo Avançado (Mock)',
                amd: '20260701',
                hash: 'mock2',
                snippet: `...estudo dos limites utilizando a base ${this.queryTerm} nas operações matemáticas modernas...`
              }
            ];
        }

      } catch (error) {
        console.error('Erro ao realizar busca profunda:', error);
        
        // Em caso de catch (API fora do ar), injeta mock
        this.results = [
          {
            titulo: 'Falha na Conexão API - Resultado Teste',
            amd: '20260701',
            hash: 'mockerr',
            snippet: `...houve um erro ao buscar na API, mas o frontend destacará a palavra ${this.queryTerm} como demonstrativo visual...`
          }
        ];
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    generateSnippet(text, term) {
      if (!text || !term) return '...';
      
      const regex = new RegExp(term, 'gi');
      const match = regex.exec(text);
      
      if (!match) return text.substring(0, 150) + '...';
      
      // Pega 60 caracteres antes e 60 depois da palavra
      const start = Math.max(0, match.index - 60);
      const end = Math.min(text.length, match.index + term.length + 60);
      
      let snippet = text.substring(start, end);
      return `...${snippet}...`;
    },
    highlightTerm(snippet) {
      if (!snippet) return '';
      if (snippet.includes('<mark>')) return snippet;
      if (!this.queryTerm) return snippet;
      const regex = new RegExp(`(${this.queryTerm})`, 'gi');
      return snippet.replace(regex, '<span class="highlight">$1</span>');
    }
  }
}
</script>

<style src="../styles/SearchResults.css"></style>